// {{ $t('立即添加') }}
// $t('立即添加')
// this.$t('立即添加')

export default {
  职员: 'Staff',
  网址: 'Url',
  职称: 'Job Title',
  官网: 'Official Website',
  营业期限: 'Business term',
  组织机构代码: 'Organization code',
  纳税人识别号: 'Taxpayer Identification No.',
  核准日期: 'Approval Date',
  当前位置: 'Current position',
  已选条件: 'Selected conditions',
  已选国内数据: 'Selected china  data',
  已选国际数据: 'Selected International Data',
  邮件邀约: 'International Invitation',
  短信邀约: 'Domestic Invitation',
  '我的客户库（默认）': 'my client library (default)',
  创建群组: 'Create a group',
  新建群组: 'Create a new group',
  请选择客户库群组: 'Please select a customer library group',
  一键添加客户库: 'Add To client library',
  已选数据: 'Selected data',
  当前共: 'Current total',
  '请输入公司名称/经营范围': 'Please enter your company name/business scope',
  关键词: 'Keywords',
  标签筛选: 'Advanced Screening',
  国内云数据: 'Domestic Cloud Data',
  '国际（港澳台）云数据': 'International (Hong Kong, Macau, Taiwan) Cloud Data',
  语言: 'Language',
  搜索范围: 'Search Scope',
  省份地区: 'Province Area',
  热门: 'Popular',
}
